import { render, staticRenderFns } from "./address-group.vue?vue&type=template&id=57cf077a&scoped=true&"
import script from "./address-group.vue?vue&type=script&lang=js&"
export * from "./address-group.vue?vue&type=script&lang=js&"
import style0 from "./address-group.vue?vue&type=style&index=0&id=57cf077a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf077a",
  null
  
)

/* custom blocks */
import block0 from "./address-group.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports